module.exports = __webpack_public_path__ + "static/media/LanternCityMarketEXTA0002_design_clean_v001.27117498.webp";